import { RefObject, useEffect, useState } from 'react';

import debounce from 'lodash/debounce';

export const useScrollPosition = (scrollableRef?: RefObject<HTMLElement>) => {
    const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        const isWindow = scrollableRef === undefined && typeof window !== 'undefined';
        const el = scrollableRef?.current || (isWindow ? window : null);

        const handleScroll = debounce(() => {
            const position = el?.scrollTop || (isWindow ? window.scrollY : 0);
            setScrollPosition(position);
        }, 250);

        if (typeof el !== 'undefined') {
            el?.addEventListener('scroll', handleScroll, { passive: true });

            return () => {
                el?.removeEventListener('scroll', handleScroll);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return scrollPosition;
};
